import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import DateConverter from '../Tools/DateConverter';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
const productos = [{ 'id': 1, 'nombre': 'POLLO', 'idProductos': [10, 11, 12, 13] }, { 'id': 2, 'nombre': 'PIPOCA', 'idProductos': [111, 1801] },
{ 'id': 3, 'nombre': 'PAPA', 'idProductos': [111, 1801] }, { 'id': 4, 'nombre': 'ARROZ', 'idProductos': [121, 1802] }, { 'id': 5, 'nombre': 'ARROZ-FRIJOL', 'idProductos': [122] }]
function HistoricoVentaSemanal() {
    const {setLoading} = useContext(ContextGloball)
    const [almacenes, setAlmacenes] = useState([]);
    const [idAlmacen, setIdAlmacen] = useState(0);
    const [idProducto, setIdProducto] = useState(0);
    const [fecha, setFecha] = useState(DateConverter.getFechHoyFormaroDefault());
    const [sucursales, setSucursales] = useState([]);
    const [fechaSelect, setFechaSelect] = useState(false);
    const [regional, setRegional] = useState('');
    const [resultados, setResultados] = useState([]);
    function getAlmacenes() {
        const datos = JSON.parse(localStorage.getItem("__react_session__"));
        if (datos != undefined && datos != null && almacenes.length == 0 && sucursales.length == 0) {
            setRegional(datos.regional);
            fetch(`${server}/reporte/getAlamacenesRegional`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: datos.regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        console.log(data.ok);
                        setAlmacenes(data.ok);
                    }

                })
                .catch(error => MsgUtils.msgError(error));
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: datos.regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        //getInformacionProyeccion();
                        console.log(data.ok)
                        setSucursales(data.ok);
                    }

                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    function cambiarFecha(fecha) {
        var fechaActual = new Date();
        var fechaSeleccionada = fecha.split('-');
        if (fechaActual.getFullYear() >= parseInt(fechaSeleccionada[0]) && ((fechaActual.getMonth() + 1) > parseInt(fechaSeleccionada[1]) ||(fechaActual.getMonth() + 1) == parseInt(fechaSeleccionada[1]) && fechaActual.getDate() >= parseInt(fechaSeleccionada[2]))){
            fechaSeleccionada = new Date(fechaSeleccionada[0], fechaSeleccionada[1] - 1, fechaSeleccionada[2]);
            if (fechaSeleccionada.getDay() == 1) {
                setFecha(fecha);
                setFechaSelect(true);
            } else {
                if (fechaSeleccionada.getDay() > 1) {
                    fechaSeleccionada.setDate(fechaSeleccionada.getDate() - (fechaSeleccionada.getDay() - 1));
                    setFecha(`${fechaSeleccionada.getFullYear()}-${(fechaSeleccionada.getMonth() + 1) < 10 ? `0${(fechaSeleccionada.getMonth() + 1)}` : (fechaSeleccionada.getMonth() + 1)}-${fechaSeleccionada.getDate() < 10 ? `0${fechaSeleccionada.getDate()}` : fechaSeleccionada.getDate()}`)
                } else {
                    fechaSeleccionada.setDate(fechaSeleccionada.getDate() - 6);
                    setFecha(`${fechaSeleccionada.getFullYear()}-${(fechaSeleccionada.getMonth() + 1) < 10 ? `0${(fechaSeleccionada.getMonth() + 1)}` : (fechaSeleccionada.getMonth() + 1)}-${fechaSeleccionada.getDate() < 10 ? `0${fechaSeleccionada.getDate()}` : fechaSeleccionada.getDate()}`)
                }
                setFechaSelect(true);
            }
        } else {
            setFechaSelect(false);
            MsgUtils.msgError("No se permite fechas futuras.")
        }
    }
    const buscarProductoVenta = async () => {
        if (idProducto != 0 && idAlmacen != 0 && fechaSelect != false) {
            setLoading(true);
            var datosAntiguo = resultados;
            setResultados([]);
            var productoSel = productos.filter(item => item.id == idProducto)[0];
            var resultPrevio = [fecha];
            fetch(`${server}/reporte/getHistoVentasSucursal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idAlmacen, 'idProducto': `${productoSel.idProductos}`, 'sucursales': sucursales.map(item => item.ID_SUCURSAL), fecha, regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        console.log(data.ok)
                        setResultados([...datosAntiguo, data.ok]);
                    }
                    setLoading(false);
                })
            
        } else {
            MsgUtils.msgError("Seleccione los parametros necesarios")
        }
    }
    useEffect(() => {
        getAlmacenes()
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '210px' }}>
                        <div className="input-group input-group-sm w-100">
                            <span className="input-group-text text-light bg-transparent" style={{ border: 'none' }}>Almacen</span>
                            <select className="form-select form-select-sm" value={idAlmacen} onChange={(e) => {setResultados([]);setIdAlmacen(e.target.value)}}>
                                <option value={0}>Ninguno</option>
                                {almacenes.map((item, index) => {
                                    return (<option value={item.ID_ALMACEN} key={index}>{item.DESCRIPCION}</option>)
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '210px' }}>
                        <div className="input-group input-group-sm ">
                            <span className="input-group-text text-light bg-transparent" style={{ border: 'none' }}>Producto</span>
                            <select className="form-select form-select-sm" value={idProducto} onChange={(e) => {setResultados([]);setIdProducto(e.target.value)}}>
                                <option value={0}>Ninguno</option>
                                {productos.map((item, index) => {
                                    return (<option value={item.id} key={index}>{item.nombre}</option>)
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '200px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text text-light bg-transparent" style={{ border: 'none' }}>Fecha</span>
                            <input type="date" className="form-control" value={fecha} onChange={(e) => cambiarFecha(e.target.value)}></input>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px' }}>
                        <button className='btn btn-success btn-sm w-100' onClick={() => buscarProductoVenta()}>
                            <i className="fa-solid fa-magnifying-glass-plus"></i> buscar
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-striped table-dark table-hover table-sm table-bordered border-secondary">
                    <thead>
                        <tr>
                            <th scope="col">FECHA</th>
                            {sucursales.map((item, index) => {
                                return (<th key={index}>{item.SUCURSAL}</th>)
                            })}

                        </tr>
                    </thead>
                    <tbody>
                        {resultados.map((item, index) => {
                            return (
                                <tr key={index}>
                                    {item.map((itemm, indexx) => {
                                        return (<td key={indexx}>{itemm}</td>)
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default HistoricoVentaSemanal